import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const FILE_URL = (path) => `${API}/files/${path}`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Admin
export const adminGetStats = async () => (await api.get("/admin/stats")).data;
export const adminListUsers = async (q = "", limit = 200, skip = 0) =>
  (
    await api.get("/admin/users", {
      params: { q: q || undefined, limit, skip },
    })
  ).data;
export const adminPatchUser = async (userId, patch) =>
  (await api.patch(`/admin/users/${userId}`, patch)).data;
export const adminDeleteUser = async (userId) =>
  (await api.delete(`/admin/users/${userId}`)).data;
export const adminListOffers = async (q = "", limit = 200, skip = 0) =>
  (
    await api.get("/admin/offers", {
      params: { q: q || undefined, limit, skip },
    })
  ).data;
export const adminDeleteOffer = async (offerId) =>
  (await api.delete(`/admin/offers/${offerId}`)).data;
export const adminListWorkspaces = async () =>
  (await api.get("/admin/workspaces")).data;
export const adminDeleteWorkspace = async (workspaceId) =>
  (await api.delete(`/admin/workspaces/${workspaceId}`)).data;
export const adminGetConfig = async () => (await api.get("/admin/config")).data;
export const adminPatchConfig = async (patch) =>
  (await api.patch("/admin/config", patch)).data;

// Auth
export const getMe = async () => (await api.get("/auth/me")).data;
export const getAppConfig = async () => (await api.get("/config")).data;
export const exchangeSession = async (sessionId) =>
  (await api.post("/auth/session", { session_id: sessionId })).data;
export const logout = async () => api.post("/auth/logout");

// Brand voice + logo
export const updateBrandVoice = async (voice) =>
  (await api.put("/auth/me/brand-voice", voice)).data;
export const uploadLogo = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return (
    await api.put("/auth/me/logo", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
  ).data;
};
export const removeLogo = async () => (await api.delete("/auth/me/logo")).data;

// Offers
export const generateOffer = async (payload, workspaceId) => {
  const q = workspaceId ? `?workspace_id=${encodeURIComponent(workspaceId)}` : "";
  return (await api.post(`/offers/generate${q}`, payload)).data;
};
export const refineOffer = async (id, instructions) =>
  (await api.post(`/offers/${id}/refine`, { instructions })).data;
export const listOffers = async () => (await api.get("/offers")).data;
export const getOffer = async (id) => (await api.get(`/offers/${id}`)).data;
export const deleteOffer = async (id) =>
  (await api.delete(`/offers/${id}`)).data;
export const setOfferVisibility = async (id, hideInputOnShare) =>
  (
    await api.patch(`/offers/${id}/visibility`, {
      hide_input_on_share: hideInputOnShare,
    })
  ).data;
export const emailOffer = async (id, recipientEmail) =>
  (
    await api.post(`/offers/${id}/email`, {
      recipient_email: recipientEmail || null,
    })
  ).data;

// Payments
export const listPackages = async () =>
  (await api.get("/payments/packages")).data;
export const createCheckout = async (packageId, originUrl) =>
  (
    await api.post("/payments/checkout", {
      package_id: packageId,
      origin_url: originUrl,
    })
  ).data;
export const paymentStatus = async (sessionId) =>
  (await api.get(`/payments/status/${sessionId}`)).data;

// Workspaces
export const listWorkspaces = async () =>
  (await api.get("/workspaces")).data;
export const createWorkspace = async (name) =>
  (await api.post("/workspaces", { name })).data;
export const inviteToWorkspace = async (workspaceId, email) =>
  (await api.post(`/workspaces/${workspaceId}/invite`, { email })).data;
export const removeWorkspaceMember = async (workspaceId, email) =>
  (
    await api.delete(
      `/workspaces/${workspaceId}/members/${encodeURIComponent(email)}`
    )
  ).data;
export const deleteWorkspace = async (workspaceId) =>
  (await api.delete(`/workspaces/${workspaceId}`)).data;

// Analytics
export const myAnalytics = async () =>
  (await api.get("/analytics/me")).data;
